import { type Duration } from 'date-fns';
import { parse as parseISO8601Duration } from 'iso8601-duration';
import { PromocodeViewModel } from '@common/model/billing/promocode';
import { addDurations } from '../../../shared/lib';

export const getAccumulativeDuration = (promos: Pick<PromocodeViewModel, 'freePeriod'>[]): Duration =>
  promos.reduce<Duration>((acc, promo) => (promo.freePeriod ? addDurations(acc, parseISO8601Duration(promo.freePeriod)) : acc), {});
